import React from 'react';
import { RiArrowRightSLine } from 'react-icons/ri';
import ModalContainer from '../../ModalContainer';
import DeleteChatHistory from '../../DeleteChatHistory';
import DeleteAccountModal from '../../DeleteAccountModal';
import { SecurityTabStyle } from './SecurityTab.styles';

const SecurityTab = () => {
  return (
    <>
      <SecurityTabStyle>
        <div className="info-list">
          <ModalContainer
            width="700"
            title="Delete all chats"
            content={({ onClose }) => <DeleteChatHistory onClose={onClose} />}
            btnComponent={({ onClick }) => (
              <button type="button" className="btn" onClick={onClick}>
                <strong className="title">Clear chat history</strong>
                <span className="text">Delete all messages and conversations permanently.</span>
                <RiArrowRightSLine className="icon" />
              </button>
            )}
          />
          <ModalContainer
            width="700"
            title="Confirm Account Deletion"
            content={({ onClose }) => <DeleteAccountModal onClose={onClose} />}
            btnComponent={({ onClick }) => (
              <button type="button" className="btn" onClick={onClick}>
                <strong className="title">Delete my account</strong>
                <span className="text">Permanently delete you Feeda.ai account.</span>
                <RiArrowRightSLine className="icon" />
              </button>
            )}
          />
        </div>
      </SecurityTabStyle>
    </>
  );
};

export default SecurityTab;
